/**
 * Authenticated file links (sales rework Phase 8).
 *
 * /uploads/attachments is gated server-side (it holds commercial/sensitive
 * files); plain <a href>/<img src> can't send the Authorization header, so
 * links to that subpath carry the JWT as ?access_token=. Image subpaths
 * (asset-types, logos, engineers) remain public and pass through untouched.
 */

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export function authedFileHref(url) {
  if (!url) return url;
  const absolute = url.startsWith('/uploads/') ? `${API_BASE}${url}` : url;
  if (!absolute.includes('/uploads/attachments/')) return absolute;
  const token = localStorage.getItem('token');
  if (!token) return absolute;
  return `${absolute}${absolute.includes('?') ? '&' : '?'}access_token=${encodeURIComponent(token)}`;
}

export default authedFileHref;
